import script from "./HeaderWaitingList.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderWaitingList.vue?vue&type=script&setup=true&lang=js"

import "./HeaderWaitingList.vue?vue&type=style&index=0&id=0e78ff48&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e78ff48"]])

export default __exports__